<script>
    import {createEventDispatcher} from 'svelte';
    import Boton from "../../../../assets/src/Components/UI/Boton.svelte";

    const dispatch = createEventDispatcher();
    const enviaNumero = numero => () => dispatch('tecla', numero);
    const borrar = () => dispatch('borrar');
</script>

<div class="teclado">
    {#each [1, 2, 3, 4, 5, 6, 7, 8, 9, 0] as numero}
        <div class="tecla">
            <Boton ancho on:click={enviaNumero(numero)} tipo="neutral">
                {numero}
            </Boton>
        </div>
    {/each}

    <div class="tecla tecla-doble">
        <Boton ancho on:click={borrar}>Borrar</Boton>
    </div>
</div>

<style>
    .teclado {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 0 18px;
        font-size: 8vw;
        margin-top: 20px;
    }

    .tecla-doble {
        grid-column: 2 / 4;
    }

    @media only screen and (min-width: 562px) {
        .teclado {
            font-size: 3em;
        }
    }
</style>